import { ErrorCode } from 'libs.react';
export const API_ERROR_MESSAGES = {
    [ErrorCode.ACCESS_DENIED_ACCOUNT_LOCKED]: {
        title: 'Account locked',
        subtitle: 'Your account has been temporarily locked. Please try again later.',
    },
    [ErrorCode.ACCESS_DENIED_SSO_REQUIRED]: {
        title: 'SSO required',
        subtitle: 'Password login is disabled for your account. Please use SSO to sign in.',
    },
    [ErrorCode.ACCESS_DENIED_INVALID_CREDENTIALS]: {
        title: 'Invalid credentials',
        subtitle: 'The email or password you entered is incorrect. Please check your credentials and try again. If you have forgotten your password, you can reset it using the "Forgot password" link.',
    },
    [ErrorCode.ACCESS_DENIED_PASSWORD_EXPIRED]: {
        title: 'Password expired',
        subtitle: 'The password has expired. Please check your credentials or try reset your password',
    },
    [ErrorCode.ACCESS_DENIED_INVALID_TOKEN]: {
        title: 'Session expired',
        subtitle: 'It seems like your session has expired or you have been signed out. Please sign in again to continue using the application.',
    },
    [ErrorCode.ACCESS_DENIED_REDEPLOYMENT]: {
        title: 'Error re-deploying study configuration',
        subtitle: 'The version you are trying to deploy requires deleting study configuration, deployment is not allowed, please contact Medable to request for assistance deploying this version.',
    },
    [ErrorCode.ACCESS_DENIED_TARGET_ORG]: {
        title: 'Access denied',
        subtitle: 'You do not have permission to update the environment. Please ask the owner of the environment to grant you Administrator permissions in the environment.',
    },
    [ErrorCode.ACCESS_DENIED_UPDATE_ENVIRONMENT_ACCESS]: {
        title: 'Access denied',
        subtitle: 'You do not have access to this environment. Ask your workspace or environment owner for access.',
    },
    [ErrorCode.ACCESS_DENIED_STUDY_DEPLOYMENT_ACCESS]: {
        title: 'Access denied',
        subtitle: 'You do not have permission to deploy to this environment. Ask your workspace or environment owner for access.',
    },
    [ErrorCode.CONFLICT_INSTANCE_DELETE]: {
        title: 'Unable to delete study',
        subtitle: 'You are unable to delete a study with a sandbox or production environment. Please contact Medable for additional assistance.',
    },
    [ErrorCode.ENTITY_ACCESS_EXISTS]: {
        title: 'Duplicate email address',
        subtitle: 'The email provided already exists in this or other workspace. Email address must be unique across all Medable Workspaces. To resolve, use a different email address.',
    },
    [ErrorCode.EXISTING_SITE_IN_ENVIRONMENT]: {
        title: 'Site already exists in environment',
        subtitle: 'The selected site already exists in the environment. Please select a different site.',
    },
    [ErrorCode.IDENTITY_NOT_VERIFIED]: {
        title: 'Identity not verified',
        subtitle: 'Your account has not been verified. Please verify your account by clicking the link in the email sent to you.',
    },
    [ErrorCode.PROD_ENVIRONMENT_LIMIT_REACHED]: {
        title: 'Unable to create a new deployment',
        subtitle: 'You have reached the limit of environments in the selected region. Please select a different region or use the Update feature to update any of your existing environments.',
    },
    [ErrorCode.PASSWORD_STRENGTH]: {
        title: 'Password strength',
        subtitle: 'Your password does not meet the minimum strength requirements. Use a stronger password to continue. Try a longer password, a phrase with random words, or add numbers and symbols to make it harder to guess.',
    },
    [ErrorCode.SITE_NUMBER_EXISTS]: {
        title: 'Site number already exists',
        subtitle: 'The site number you provided already exists. Please choose a different site number.',
    },
    [ErrorCode.USED_PASSWORD]: {
        title: 'Password already used',
        subtitle: 'You have used this password before. Please choose a password that you have not used before.',
    },
    [ErrorCode.INVALID_ARGUMENT_INVALID_TOKEN]: {
        title: 'Invalid or expired token',
        subtitle: 'This token is invalid or has expired. Please request a new one and try again.',
    },
};
export var ApiClientService;
(function (ApiClientService) {
    ApiClientService["IAM"] = "iam";
    ApiClientService["LIBRARY"] = "library";
    ApiClientService["MOM"] = "mom";
    ApiClientService["CLOUD"] = "cloud";
    ApiClientService["WEB"] = "web";
    ApiClientService["AUTOBUILD"] = "autobuild";
    ApiClientService["SG"] = "sg";
    ApiClientService["STAT"] = "stat";
    ApiClientService["CONTROL"] = "control";
    ApiClientService["AGENT_STUDIO_API"] = "agents";
    ApiClientService["SENTINEL"] = "sentinel";
})(ApiClientService || (ApiClientService = {}));
export const ApiClientEndpointsByService = {
    [ApiClientService.IAM]: process.env.IAM_SERVICE_ENDPOINT,
    [ApiClientService.LIBRARY]: process.env.LIBRARY_SERVICE_ENDPOINT,
    [ApiClientService.MOM]: process.env.MOM_SERVICE_ENDPOINT,
    [ApiClientService.CLOUD]: process.env.CLOUD_SERVICE_ENDPOINT,
    [ApiClientService.WEB]: process.env.WEB_ENDPOINT,
    [ApiClientService.AUTOBUILD]: process.env.AUTOBUILD_ENDPOINT,
    [ApiClientService.SG]: process.env.SG_SERVICE_ENDPOINT,
    [ApiClientService.STAT]: process.env.STUDY_TEST_AUTOMATION_TOOL_ENDPOINT,
    [ApiClientService.CONTROL]: process.env.CONTROL_SERVICE_ENDPOINT,
    [ApiClientService.AGENT_STUDIO_API]: process.env.AGENT_STUDIO_API_ENDPOINT,
    [ApiClientService.SENTINEL]: process.env.SENTINEL_SERVICE_ENDPOINT,
};
